
const COPY_COMMAND = 'npx blognami@latest generate-project my-blog';
const GITHUB_URL = 'https://github.com/blognami/blognami';
const DOCS_URL = '/docs';
const SIGN_UP_URL = '/_actions/guest/sign_in?title=Sign%20up&returnUrl=%2F_actions%2Fuser%2Fadd_blog';
const ADD_BLOG_URL = '/_actions/user/add_blog';

export const styles = ({ remify, breakpointFor, colors }) => {
    const navy = colors.blue[900];
    const accent = colors.semantic.accent;
    const mono = `'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace`;

    return `
        .page {
            color: #29374A;
        }

        .section {
            max-width: ${remify(1200)};
            margin: 0 auto;
            width: 100%;
        }

        .eyebrow {
            font-family: ${mono};
            font-size: ${remify(12)};
            font-weight: 500;
            letter-spacing: 0.16em;
            text-transform: uppercase;
            color: ${navy};
        }

        /* ===== Hero ===== */
        .hero {
            padding: ${remify(56)} ${remify(24)} ${remify(40)};
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: ${remify(22)};
        }

        .hero-title {
            margin: 0;
            font-size: ${remify(34)};
            line-height: 1.05;
            font-weight: 700;
            letter-spacing: -0.025em;
            max-width: ${remify(840)};
            color: #26313F;
        }

        .hero-title em {
            font-style: normal;
            color: ${accent};
        }

        .hero-subtitle {
            margin: 0;
            font-size: ${remify(18)};
            line-height: 1.6;
            color: #4A5564;
            max-width: ${remify(580)};
        }

        .cta-row {
            display: flex;
            flex-direction: column;
            align-items: stretch;
            gap: ${remify(12)};
            width: 100%;
            max-width: ${remify(360)};
            margin-top: ${remify(8)};
        }

        .cta {
            padding: ${remify(14)} ${remify(28)};
            border-radius: ${remify(8)};
            font-weight: 600;
            font-size: ${remify(16)};
            text-align: center;
            cursor: pointer;
            transition: opacity 0.15s ease, background-color 0.15s ease;
        }

        .cta-primary {
            background: ${navy};
            color: #fff;
        }

        .cta-primary:hover {
            opacity: 0.92;
        }

        .cta-secondary {
            border: ${remify(1)} solid #D6DDE5;
            color: #29374A;
        }

        .cta-secondary:hover {
            background: #F6F8FA;
        }

        .copy-command {
            margin-top: ${remify(6)};
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: ${remify(12)};
            background: #F6F8FA;
            border: ${remify(1)} solid #E3E8EE;
            border-radius: ${remify(10)};
            padding: ${remify(13)} ${remify(16)};
            font-family: ${mono};
            font-size: ${remify(12.5)};
            line-height: 1.5;
            color: #4A5564;
            max-width: 100%;
            text-align: left;
        }

        .copy-command-prompt {
            color: ${accent};
        }

        .copy-command-text {
            flex: 1;
            min-width: 0;
            word-break: break-word;
        }

        .copy-command-label {
            color: ${navy};
            font-weight: 700;
            border-left: ${remify(1)} solid #E3E8EE;
            padding-left: ${remify(14)};
            white-space: nowrap;
        }

        /* ===== Editor preview ===== */
        .editor {
            padding: 0 ${remify(24)} ${remify(56)};
        }

        .editor-card {
            border-radius: ${remify(14)};
            border: ${remify(1)} solid #E7EBF0;
            background: #fff;
            overflow: hidden;
            box-shadow: 0 ${remify(20)} ${remify(50)} -${remify(32)} rgba(32, 55, 90, 0.35);
        }

        .editor-bar {
            display: flex;
            align-items: center;
            gap: ${remify(8)};
            padding: ${remify(14)} ${remify(18)};
            border-bottom: ${remify(1)} solid #EDF0F4;
            background: #FBFCFD;
        }

        .editor-dot {
            width: ${remify(11)};
            height: ${remify(11)};
            border-radius: 50%;
            background: #DBE1E8;
        }

        .editor-bar-title {
            margin-left: ${remify(8)};
            font-size: ${remify(12)};
            font-weight: 500;
            color: #9AA4B2;
        }

        .editor-body {
            display: block;
        }

        .editor-source {
            padding: ${remify(26)} ${remify(24)};
            font-family: ${mono};
            font-size: ${remify(13.5)};
            line-height: 1.9;
            color: #4A5564;
            border-bottom: ${remify(1)} solid #EDF0F4;
            background: #fff;
        }

        .editor-source-spacer {
            height: ${remify(14)};
        }

        .editor-caret {
            display: inline-block;
            width: ${remify(7)};
            height: ${remify(16)};
            margin-left: ${remify(1)};
            vertical-align: -${remify(3)};
            background: ${navy};
            animation: blognami-landing-caret 1.1s steps(1) infinite;
        }

        @keyframes blognami-landing-caret {
            0%, 50% { opacity: 1; }
            51%, 100% { opacity: 0; }
        }

        .editor-rendered {
            padding: ${remify(28)} ${remify(24)};
        }

        .editor-rendered-title {
            font-size: ${remify(26)};
            font-weight: 700;
            letter-spacing: -0.015em;
            margin-bottom: ${remify(16)};
            line-height: 1.12;
            color: #26313F;
        }

        .editor-rendered-text {
            font-size: ${remify(16)};
            line-height: 1.7;
            color: #4A5564;
            margin-bottom: ${remify(16)};
        }

        .editor-rendered-list {
            display: flex;
            flex-direction: column;
            gap: ${remify(9)};
            font-size: ${remify(16)};
            color: #4A5564;
            margin-bottom: ${remify(18)};
        }

        .editor-rendered-list-item {
            display: flex;
            gap: ${remify(11)};
            align-items: center;
        }

        .editor-rendered-bullet {
            width: ${remify(6)};
            height: ${remify(6)};
            border-radius: 50%;
            background: ${accent};
            flex-shrink: 0;
        }

        .editor-rendered-quote {
            border-left: ${remify(3)} solid ${accent};
            padding-left: ${remify(15)};
            font-size: ${remify(18)};
            color: #5B6675;
            font-style: italic;
        }

        /* ===== Features ===== */
        .features {
            padding: ${remify(8)} ${remify(24)} ${remify(56)};
        }

        .features-header {
            text-align: center;
            margin-bottom: ${remify(32)};
        }

        .features-eyebrow {
            display: block;
            margin-bottom: ${remify(14)};
        }

        .features-heading {
            margin: 0;
            font-size: ${remify(30)};
            font-weight: 700;
            letter-spacing: -0.02em;
            color: #26313F;
        }

        .features-grid {
            display: grid;
            grid-template-columns: 1fr;
            border-top: ${remify(1)} solid #E7EBF0;
            border-left: ${remify(1)} solid #E7EBF0;
        }

        .feature-card {
            border-right: ${remify(1)} solid #E7EBF0;
            border-bottom: ${remify(1)} solid #E7EBF0;
            padding: ${remify(28)} ${remify(24)};
            display: flex;
            flex-direction: column;
            gap: ${remify(11)};
        }

        .feature-id {
            font-family: ${mono};
            font-size: ${remify(13)};
            font-weight: 700;
            color: ${accent};
        }

        .feature-name {
            font-size: ${remify(19)};
            font-weight: 700;
            letter-spacing: -0.01em;
            color: #26313F;
        }

        .feature-blurb {
            font-size: ${remify(15)};
            line-height: 1.6;
            color: #6F7A89;
        }

        /* ===== Tiers ===== */
        .tiers {
            padding: ${remify(8)} ${remify(24)} ${remify(56)};
        }

        .tiers-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: ${remify(20)};
        }

        .tier-card {
            border: ${remify(1)} solid #E7EBF0;
            border-radius: ${remify(16)};
            padding: ${remify(30)} ${remify(26)};
            background: #fff;
        }

        .tier-card-featured {
            border: ${remify(1.5)} solid ${navy};
        }

        .tier-title {
            font-size: ${remify(24)};
            font-weight: 700;
            letter-spacing: -0.01em;
            margin-bottom: ${remify(5)};
            color: #26313F;
        }

        .tier-tag {
            font-family: ${mono};
            font-size: ${remify(11)};
            font-weight: 500;
            letter-spacing: 0.12em;
            margin-bottom: ${remify(26)};
        }

        .tier-tag-self-host { color: ${accent}; }
        .tier-tag-hosted { color: ${navy}; }

        .tier-list {
            display: flex;
            flex-direction: column;
            gap: ${remify(15)};
            font-size: ${remify(16)};
            color: #41505F;
        }

        .tier-item {
            display: flex;
            gap: ${remify(12)};
        }

        .tier-check {
            color: ${accent};
            font-weight: 700;
            flex-shrink: 0;
        }

        /* ===== Open source band ===== */
        .band-section {
            padding: ${remify(8)} ${remify(24)} ${remify(64)};
        }

        .band {
            border-radius: ${remify(18)};
            background: ${navy};
            color: #EAF1F8;
            padding: ${remify(40)} ${remify(28)};
            display: flex;
            flex-direction: column;
            gap: ${remify(24)};
        }

        .band-text {
            max-width: ${remify(580)};
            display: flex;
            flex-direction: column;
            gap: ${remify(13)};
        }

        .band-heading {
            margin: 0;
            font-size: ${remify(28)};
            font-weight: 700;
            letter-spacing: -0.02em;
            color: #fff;
        }

        .band-subtitle {
            margin: 0;
            font-size: ${remify(16.5)};
            line-height: 1.6;
            color: #A7BBD4;
        }

        .band-actions {
            display: flex;
            flex-direction: column;
            gap: ${remify(12)};
        }

        .band-cta {
            padding: ${remify(14)} ${remify(26)};
            border-radius: ${remify(8)};
            font-size: ${remify(15)};
            text-align: center;
            cursor: pointer;
            transition: opacity 0.15s ease;
        }

        .band-cta:hover { opacity: 0.92; }

        .band-cta-primary {
            background: #fff;
            color: ${navy};
            font-weight: 700;
        }

        .band-cta-secondary {
            border: ${remify(1)} solid rgba(255, 255, 255, 0.25);
            color: #EAF1F8;
            font-weight: 600;
        }

        /* ===== md: tablet and up ===== */
        ${breakpointFor('md')} {
            .hero {
                padding: ${remify(80)} ${remify(32)} ${remify(56)};
                gap: ${remify(26)};
            }

            .hero-title { font-size: ${remify(48)}; }
            .hero-subtitle { font-size: ${remify(19)}; }

            .cta-row {
                flex-direction: row;
                align-items: center;
                justify-content: center;
                flex-wrap: wrap;
                width: auto;
                max-width: none;
            }

            .copy-command { font-size: ${remify(13.5)}; }

            .editor { padding: ${remify(16)} ${remify(32)} ${remify(72)}; }

            .editor-body {
                display: grid;
                grid-template-columns: 1fr 1fr;
            }

            .editor-source {
                padding: ${remify(30)};
                border-bottom: none;
                border-right: ${remify(1)} solid #EDF0F4;
            }

            .editor-rendered { padding: ${remify(34)} ${remify(38)}; }
            .editor-rendered-title { font-size: ${remify(28)}; }

            .features { padding: ${remify(8)} ${remify(32)} ${remify(72)}; }
            .features-heading { font-size: ${remify(38)}; }
            .features-grid { grid-template-columns: repeat(2, 1fr); }
            .feature-card { padding: ${remify(32)} ${remify(30)}; }

            .tiers { padding: ${remify(8)} ${remify(32)} ${remify(72)}; }
            .tiers-grid { grid-template-columns: repeat(2, 1fr); }
            .tier-card { padding: ${remify(38)} ${remify(34)}; }

            .band-section { padding: ${remify(8)} ${remify(32)} ${remify(80)}; }
            .band {
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: ${remify(32)};
                padding: ${remify(54)} ${remify(48)};
            }
            .band-actions { flex-direction: row; flex-wrap: wrap; }
            .band-heading { font-size: ${remify(34)}; }
        }

        /* ===== lg: desktop ===== */
        ${breakpointFor('lg')} {
            .hero { padding: ${remify(88)} ${remify(40)} ${remify(64)}; }
            .hero-title { font-size: ${remify(64)}; }
            .editor { padding: ${remify(16)} ${remify(40)} ${remify(80)}; }
            .features { padding: ${remify(8)} ${remify(40)} ${remify(80)}; }
            .features-grid { grid-template-columns: repeat(3, 1fr); }
            .tiers { padding: ${remify(8)} ${remify(40)} ${remify(80)}; }
            .band-section { padding: ${remify(8)} ${remify(40)} ${remify(88)}; }
        }
    `;
};

export const decorators = {
    copyCommand(){
        this.on('click', () => {
            try {
                navigator.clipboard?.writeText(COPY_COMMAND);
            } catch(e) {}

            const label = this.find('[data-copy-label]');
            if(!label) return;

            label.node.textContent = 'Copied';
            this.setTimeout(() => { label.node.textContent = 'Copy'; }, 1600);
        });
    }
};

const FEATURES = [
    { id: '01', name: 'Markdown-first editing', blurb: 'Write in a plain markdown editor with live preview. Minimal, fast, focused.' },
    { id: '02', name: 'Passwordless auth', blurb: 'One-time codes by default. Smoother sign-in, fewer secrets to store.' },
    { id: '03', name: 'Posts & Pages', blurb: 'Posts for your timeline, pages for evergreen content.' },
    { id: '04', name: 'Tag system', blurb: 'Organize and surface your writing with flexible, trending tags.' },
    { id: '05', name: 'Multi-tenant ready', blurb: 'Run multiple blogs from a single install, out of the box.' },
    { id: '06', name: 'Self-hosting friendly', blurb: 'SQLite for dev, heavier databases for production. Zero bloat.' }
];

const SELF_HOST_FEATURES = [
    'Local dev in minutes',
    'Use your infra + CI/CD',
    'Extend and customize freely',
    'MIT licensed and transparent'
];

const HOSTED_FEATURES = [
    'Free tier — no credit card',
    'Secure & maintained for you',
    'Export anytime',
    'Focus purely on writing'
];

export default {
    async render(){
        const isSignedIn = await this.isSignedIn;

        const body = this.renderHtml`
            <div class="${this.cssClasses.page}">
                <section class="${this.cssClasses.section} ${this.cssClasses.hero}">
                    <div class="${this.cssClasses.eyebrow}">Markdown-first publishing</div>
                    <h1 class="${this.cssClasses.heroTitle}">A calmer place to <em>publish</em>.</h1>
                    <p class="${this.cssClasses.heroSubtitle}">Free to use. $5/month for your own domain. Or self-host for nothing.</p>
                    <div class="${this.cssClasses.ctaRow}">
                        <a class="${this.cssClasses.cta} ${this.cssClasses.ctaPrimary}" href="${isSignedIn ? ADD_BLOG_URL : SIGN_UP_URL}" target="_overlay" data-test-id="start-free">Start free</a>
                        <a class="${this.cssClasses.cta} ${this.cssClasses.ctaSecondary}" href="${DOCS_URL}">Read the docs</a>
                    </div>
                    <div class="${this.cssClasses.copyCommand}" role="button" tabindex="0">
                        <span class="${this.cssClasses.copyCommandPrompt}">$</span>
                        <span class="${this.cssClasses.copyCommandText}">${COPY_COMMAND}</span>
                        <span class="${this.cssClasses.copyCommandLabel}" data-copy-label>Copy</span>
                    </div>
                </section>

                <section class="${this.cssClasses.section} ${this.cssClasses.editor}">
                    <div class="${this.cssClasses.editorCard}">
                        <div class="${this.cssClasses.editorBar}">
                            <span class="${this.cssClasses.editorDot}"></span>
                            <span class="${this.cssClasses.editorDot}"></span>
                            <span class="${this.cssClasses.editorDot}"></span>
                            <span class="${this.cssClasses.editorBarTitle}">A calmer place to publish</span>
                        </div>
                        <div class="${this.cssClasses.editorBody}">
                            <div class="${this.cssClasses.editorSource}">
                                <div># A calmer place to publish</div>
                                <div class="${this.cssClasses.editorSourceSpacer}"></div>
                                <div>Writing should feel *effortless*.</div>
                                <div class="${this.cssClasses.editorSourceSpacer}"></div>
                                <div>- Distraction-free editor</div>
                                <div>- Passwordless sign-in</div>
                                <div>- Posts, pages &amp; tags</div>
                                <div class="${this.cssClasses.editorSourceSpacer}"></div>
                                <div>&gt; Own your words.<span class="${this.cssClasses.editorCaret}"></span></div>
                            </div>
                            <div class="${this.cssClasses.editorRendered}">
                                <div class="${this.cssClasses.editorRenderedTitle}">A calmer place to publish</div>
                                <div class="${this.cssClasses.editorRenderedText}">Writing should feel <em>effortless</em>.</div>
                                <div class="${this.cssClasses.editorRenderedList}">
                                    <div class="${this.cssClasses.editorRenderedListItem}"><span class="${this.cssClasses.editorRenderedBullet}"></span>Distraction-free editor</div>
                                    <div class="${this.cssClasses.editorRenderedListItem}"><span class="${this.cssClasses.editorRenderedBullet}"></span>Passwordless sign-in</div>
                                    <div class="${this.cssClasses.editorRenderedListItem}"><span class="${this.cssClasses.editorRenderedBullet}"></span>Posts, pages &amp; tags</div>
                                </div>
                                <div class="${this.cssClasses.editorRenderedQuote}">Own your words.</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="${this.cssClasses.section} ${this.cssClasses.features}">
                    <div class="${this.cssClasses.featuresHeader}">
                        <span class="${this.cssClasses.eyebrow} ${this.cssClasses.featuresEyebrow}">Everything you need</span>
                        <h2 class="${this.cssClasses.featuresHeading}">Nothing you don't.</h2>
                    </div>
                    <div class="${this.cssClasses.featuresGrid}">
                        ${FEATURES.map(feature => this.renderHtml`
                            <div class="${this.cssClasses.featureCard}">
                                <div class="${this.cssClasses.featureId}">${feature.id}</div>
                                <div class="${this.cssClasses.featureName}">${feature.name}</div>
                                <div class="${this.cssClasses.featureBlurb}">${feature.blurb}</div>
                            </div>
                        `)}
                    </div>
                </section>

                <section class="${this.cssClasses.section} ${this.cssClasses.tiers}">
                    <div class="${this.cssClasses.tiersGrid}">
                        <div class="${this.cssClasses.tierCard}">
                            <div class="${this.cssClasses.tierTitle}">Self-host</div>
                            <div class="${this.cssClasses.tierTag} ${this.cssClasses.tierTagSelfHost}">OPEN SOURCE · MIT</div>
                            <div class="${this.cssClasses.tierList}">
                                ${SELF_HOST_FEATURES.map(feature => this.renderHtml`
                                    <div class="${this.cssClasses.tierItem}"><span class="${this.cssClasses.tierCheck}">✓</span>${feature}</div>
                                `)}
                            </div>
                        </div>
                        <div class="${this.cssClasses.tierCard} ${this.cssClasses.tierCardFeatured}">
                            <div class="${this.cssClasses.tierTitle}">Hosted</div>
                            <div class="${this.cssClasses.tierTag} ${this.cssClasses.tierTagHosted}">SAAS · FREE TIER</div>
                            <div class="${this.cssClasses.tierList}">
                                ${HOSTED_FEATURES.map(feature => this.renderHtml`
                                    <div class="${this.cssClasses.tierItem}"><span class="${this.cssClasses.tierCheck}">✓</span>${feature}</div>
                                `)}
                            </div>
                        </div>
                    </div>
                </section>

                <section class="${this.cssClasses.section} ${this.cssClasses.bandSection}">
                    <div class="${this.cssClasses.band}">
                        <div class="${this.cssClasses.bandText}">
                            <h2 class="${this.cssClasses.bandHeading}">Built in the open.</h2>
                            <p class="${this.cssClasses.bandSubtitle}">Blognami lives in one monorepo. Star it, file ideas, open a PR — the roadmap is shaped by the people who use it.</p>
                        </div>
                        <div class="${this.cssClasses.bandActions}">
                            <a class="${this.cssClasses.bandCta} ${this.cssClasses.bandCtaPrimary}" href="${GITHUB_URL}" target="_blank" rel="noopener">★ Star on GitHub</a>
                            <a class="${this.cssClasses.bandCta} ${this.cssClasses.bandCtaSecondary}" href="${GITHUB_URL}" target="_blank" rel="noopener">View the source</a>
                        </div>
                    </div>
                </section>
            </div>
        `;

        return this.renderView('_layout', {
            title: 'Blognami',
            body,
            sidebar: '',
            meta: [
                { tagName: 'link', rel: 'preconnect', href: 'https://fonts.googleapis.com' },
                { tagName: 'link', rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: 'anonymous' },
                { tagName: 'link', rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;700&display=swap' }
            ]
        });
    }
};
